<template>
  <div>
    <!-- ✅ Full Page Loading Overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- ✅ Modal -->
    <div
      id="myModal"
      class="modal fade"
      ref="exampleModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" style="background-color: #212529">
          <div class="modal-header">
            <h5
              v-if="typeModal.text == 1"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 2"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 3x5 ทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 3"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 3x3 ทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 4"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 4x5 ทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 5"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 3600 WAYS ทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 6"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 243 WAYS ทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 7"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 720 WAYS ทุกเกม
            </h5>
            <h5
              v-else-if="typeModal.text == 8"
              class="primary"
              id="exampleModalLabel"
            >
              ปรับ RTP ของ SLOT 7x7 ทุกเกม
            </h5>
            <h5 v-else class="primary" id="exampleModalLabel">
              ปรับ RTPของเกม {{ value.text }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="hideModal"
              aria-label="Close"
            ></button>
          </div>
          <div>
            <base-dropdown>
              <a class="dropdown-item" href="#" @click="selectedValue(1)"
                >80.00 %</a
              >
              <a class="dropdown-item" href="#" @click="selectedValue(5)"
                >90.00 %</a
              >
              <a class="dropdown-item" href="#" @click="selectedValue(2)"
                >96.50 %</a
              >
              <a class="dropdown-item" href="#" @click="selectedValue(3)"
                >120.00 %</a
              >
              <a class="dropdown-item" href="#" @click="selectedValue(4)"
                >150.00 %</a
              >
            </base-dropdown>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hideModal">
              ปิด
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="isLoading"
              @click="updateValue()"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-if="!isLoading">บันทึก</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import axios from "axios";
// import ArgonAlert from "@/components/ArgonAlert.vue";
export default {
  name: "EditModal",
  components: {
    // ArgonAlert,
  },
  /*
    data: () => ({
      modalInstance: null,
      schemaname:"the_hunter",
      rtpcodex:3,
      
    }),
*/
  data() {
    return {
      isLoading: false,
      modalInstance: null,
      chemaname: "the_hunter",
      rtpcodex: 3,
      startRow: 0,
      rowsPerPage: 100,
      currentPage: 1,
      data: [],
      columns: [
        { id: "no", name: "No." },
        { id: "username", name: "username" },
        { id: "firstname", name: "ชื่อ" },
        { id: "lastname", name: "นามสกุล" },
        { id: "updated_date", name: "วันที่" },
        { id: "updated_by", name: "เวลาที่แก้ไข" },
        { id: "role", name: "สิทธิ" },
        { id: "edit", name: "" },
        { id: "delete", name: "" },
      ],
      username: "",
      isLoading: false,
      allBet: 0,
      allWinLoss: 0,
      agentList: [],
    };
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String],
      required: true,
      text: {
        type: [String],
      },
      color: {
        type: String,
      },
    },
    rtpcode: {
      type: [String],
      required: true,
      text: {
        type: [String],
      },
      color: {
        type: String,
      },
    },
    schemaname: {
      type: [String],
      required: true,
      text: {
        type: [String],
      },
      color: {
        type: String,
      },
    },
    reeltypeid: {
      type: [String],
      required: true,
      text: {
        type: [String],
      },
      color: {
        type: String,
      },
    },
    code: {
      type: [String],
      required: true,
      text: {
        type: [String],
      },
      color: {
        type: String,
      },
    },
    typeModal: {
      type: [String],
      required: true,
      text: {
        type: [String],
      },
      color: {
        type: String,
      },
    },
    allGame: {
      type: Array,
      required: true,
    },
  },

  watch: {
    showModal(newValue, oldValue) {
      if (newValue === true) {
        this.modalActive();
      }
    },
  },
  methods: {
    modalActive: function () {
      this.modalInstance = new Modal(document.getElementById("myModal"), {
        target: "#my-modal",
        backdrop: "static",
      });
      this.modalInstance.show();
    },
    hideModal: function () {
      this.modalInstance.hide();
      this.$emit("closeModal");
    },
    selectedValue(val) {
      this.rtpcodex = val;
    },
    async updateValue() {
      const token = localStorage.getItem("token"); // เก็บไว้ใช้ถ้าต้องส่ง header
      this.isLoading = true; // ✅ เริ่มโหลด

      const baseUrl = "https://dashboard-api.linkstudio.io/api/proxy"; // proxy server ของคุณ

      try {
        if (this.typeModal.text == 0) {
          console.log("Update single game");

          // 1️⃣ ยิง gamesymbol
          await axios.post(
            `${baseUrl}/api/v1/game/rtpcontrol/gamesymbol/${this.schemaname.text}/admin/${this.rtpcodex}/${this.reeltypeid.text}`,
          );

          // 2️⃣ ยิง updateGameList
          await axios.post(
            `${baseUrl}/api/v1/game/control/updateGameList/${this.code.text}/${this.rtpcodex}`,
          );
        } else {
          console.log("Update all games sequentially");

          // ยิงเกมทีละเกม
          for (const item of this.allGame) {
            console.log(`Updating game: ${item.schema_name} (${item.code})`);

            // 1️⃣ ยิง gamesymbol
            await axios.post(
              `${baseUrl}/api/v1/game/rtpcontrol/gamesymbol/${item.schema_name}/admin/${this.rtpcodex}/${item.reel_type_id}`,
            );

            // 2️⃣ ยิง updateGameList
            await axios.post(
              `${baseUrl}/api/v1/game/control/updateGameList/${item.code}/${this.rtpcodex}`,
            );
          }
        }

        // ✅ แจ้งผลผู้ใช้
        this.$swal(
          this.typeModal.text == 0
            ? "บันทึกเรียบร้อย"
            : "บันทึกเรียบร้อยสำหรับทุกเกม",
        );
        this.modalInstance.hide();
        this.$emit("closeModal");
      } catch (e) {
        console.error(e);
        this.$swal(`เกิดข้อผิดพลาด: ${e}`);
      } finally {
        this.isLoading = false; // ✅ โหลดเสร็จ
      }
    },

    updateGameList(code, rtpId) {
      axios
        .post(
          `https://dashboard-api.linkstudio.io/api/v1/game/control/updateGameList/${code}/${rtpId}`,
        )
        .then((response) => {})
        .catch((e) => {
          this.$swal(` error   ${e}`);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: #ff3838;
}
.dropdown-item {
  color: #fff;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* มืดพื้นหลัง */
  z-index: 1050; /* สูงกว่า modal backdrop */
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
}
</style>
